export const SIMILAR_LISTING_PATH = (classifiedId) => `/cdp-bff/v1/similarListings/${classifiedId}`;
export const FEEDBACK_SURVEY_PATH = (mediaID) => `/cdp-bff/v1/media-classification/${mediaID}/feedback`;
export const CALL_TRACKING_PATH = "/cdp-bff/callTracking";
export const SHARED_ASSETS_PATH = "/shared";
export const CLASSIFIED_PUBLIC_PATH = "/cdp-bff/v2/classified";
export const GEO_ROUTE_PATH = "/cdp-bff/v1/geo/route";
export const CLASSIFIED_ANALYTICS_PATH = "/cdp-bff/analytics";
